export default __webpack_public_path__ + "static/media/grid-small.e5ea2c56.svg";